<template>
  <MasterLayout page_title="فایل های مشتریان">
    <Card>
      <AjaxForm route="UserFile/Add">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput name="title" label="عنوان" type="text" placeholder="عنوان را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput label="استفاده برای" type="select" name="user_type" :select-options="userTypeOptions" placeholder="انتخاب کنید"
                         :reduce_select="(option)=>option.name" select-label="title"></CustomInput>
          </div>

          <div class="col-12 col-sm-12 col-md-6 mb-2">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="user_in_register" value="1"  name="use_in_register">
              <label class="custom-control-label" for="user_in_register">استفاده در ثبت نام</label>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 mb-2">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input"  value="1" id="required" name="required">
              <label class="custom-control-label" for="required">اجباری</label>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12">
            <CustomInput type="textarea" name="description" placeholder="توضیحات" label="توضیحات"></CustomInput>
          </div>
        </div>
        <div class="row">
          <div class="col-10 col-md-5 mx-auto">
            <button class="btn btn-primary btn-block" type="submit">ثبت اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <ImagePicker></ImagePicker>
    </Card>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import ImagePicker from "@/components/ImagePicker";
export default {
  name: "UserFileAdd",
  components: {ImagePicker, CustomInput, AjaxForm, Card, MasterLayout},
  data(){
    return{
      userTypeOptions:[
          {name : 'person',title : 'شخص حقیقی'},
          {name : 'company',title : 'شخص حقوقی'},
          {name : 'both',title : 'هردو'},
          ]
    }
  }
}
</script>

<style scoped>

</style>